/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { PartitionKeyGroup } from '../model/partitionKeyGroup';
import { PartitionKeyGroupCreateRequest } from '../model/partitionKeyGroupCreateRequest';
import { PartitionKeyGroupKeys } from '../model/partitionKeyGroupKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class PartitionKeyGroupService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createPartitionKeyGroup
     * Creates a new partition key group.
     * @param partitionKeyGroupCreateRequest the information needed to create a partition key group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partitionKeyGroupCreatePartitionKeyGroup(partitionKeyGroupCreateRequest: PartitionKeyGroupCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<PartitionKeyGroup>;
    public partitionKeyGroupCreatePartitionKeyGroup(partitionKeyGroupCreateRequest: PartitionKeyGroupCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartitionKeyGroup>>;
    public partitionKeyGroupCreatePartitionKeyGroup(partitionKeyGroupCreateRequest: PartitionKeyGroupCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartitionKeyGroup>>;
    public partitionKeyGroupCreatePartitionKeyGroup(partitionKeyGroupCreateRequest: PartitionKeyGroupCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (partitionKeyGroupCreateRequest === null || partitionKeyGroupCreateRequest === undefined) {
            throw new Error('Required parameter partitionKeyGroupCreateRequest was null or undefined when calling partitionKeyGroupCreatePartitionKeyGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PartitionKeyGroup>(`${this.configuration.basePath}/partitionKeyGroups`,
            partitionKeyGroupCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deletePartitionKeyGroup
     * Deletes an existing partition key group by name.
     * @param partitionKeyGroupName the partition key group name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partitionKeyGroupDeletePartitionKeyGroup(partitionKeyGroupName: string, observe?: 'body', reportProgress?: boolean): Observable<PartitionKeyGroup>;
    public partitionKeyGroupDeletePartitionKeyGroup(partitionKeyGroupName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartitionKeyGroup>>;
    public partitionKeyGroupDeletePartitionKeyGroup(partitionKeyGroupName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartitionKeyGroup>>;
    public partitionKeyGroupDeletePartitionKeyGroup(partitionKeyGroupName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (partitionKeyGroupName === null || partitionKeyGroupName === undefined) {
            throw new Error('Required parameter partitionKeyGroupName was null or undefined when calling partitionKeyGroupDeletePartitionKeyGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<PartitionKeyGroup>(`${this.configuration.basePath}/partitionKeyGroups/${encodeURIComponent(String(partitionKeyGroupName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPartitionKeyGroup
     * Gets an existing partition key group by name.
     * @param partitionKeyGroupName the partition key group name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partitionKeyGroupGetPartitionKeyGroup(partitionKeyGroupName: string, observe?: 'body', reportProgress?: boolean): Observable<PartitionKeyGroup>;
    public partitionKeyGroupGetPartitionKeyGroup(partitionKeyGroupName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartitionKeyGroup>>;
    public partitionKeyGroupGetPartitionKeyGroup(partitionKeyGroupName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartitionKeyGroup>>;
    public partitionKeyGroupGetPartitionKeyGroup(partitionKeyGroupName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (partitionKeyGroupName === null || partitionKeyGroupName === undefined) {
            throw new Error('Required parameter partitionKeyGroupName was null or undefined when calling partitionKeyGroupGetPartitionKeyGroup.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartitionKeyGroup>(`${this.configuration.basePath}/partitionKeyGroups/${encodeURIComponent(String(partitionKeyGroupName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPartitionKeyGroups
     * Gets a list of all existing partition key groups.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partitionKeyGroupGetPartitionKeyGroups(observe?: 'body', reportProgress?: boolean): Observable<PartitionKeyGroupKeys>;
    public partitionKeyGroupGetPartitionKeyGroups(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartitionKeyGroupKeys>>;
    public partitionKeyGroupGetPartitionKeyGroups(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartitionKeyGroupKeys>>;
    public partitionKeyGroupGetPartitionKeyGroups(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PartitionKeyGroupKeys>(`${this.configuration.basePath}/partitionKeyGroups`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
